import React, { PropTypes, useEffect, useState, useRef } from "react";
import {
  FormGroup,
  Label,
  ListGroup,
  ListGroupItem,
  Alert,
  Row,
  Col,
  Button,
} from "reactstrap";
import {
  FormField,
  FormFieldRadio,
  IconItem,
  StatusText,
} from "pickups-ui-library";
import { Field } from "redux-form";
import FormNavigation from "../navigation.component";
import { PaginatedList, PickupQuickView } from "pickups-ui-library";
import * as Icons from "pickups-ui-library/styles/icons";
import { requiredValidate } from "../../helpers";
import DropOffLocations from "../../../components/DropOffLocations";
import Modal from "pickups-ui-library/components/Modal";

let ChooseLocation = (props) => {
  const {
    handleSubmit,
    error,
    handleSelect,
    useableLocations,
    location,
    showAddNewLocation,
    dropOffLocations,
    pickupBlocks,
    zipCode,
  } = props;

  let errorMessage,
    noPickupBlocksAlert = false;

  if (error) {
    if (error === "empty") {
      noPickupBlocksAlert = true;
    } else {
      if (error.message) {
        errorMessage = error.message;
      }
    }
  }

  // const [dropOffFound, setDropOffFound] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const PickupBlockResponse = (props) => {
    const { pickupBlocks, dropOffLocations } = props;

    return (
      <div>
        {dropOffLocations.length > 0 ? (
          <>
            <Alert
              color="success"
              onClick={() => {
                setShowModal(true);
              }}
            >
              {dropOffLocations.length} drop-off locations near {zipCode}{" "}
              <Button size="sm" className="float-sm-right ml-sm-2 mt-md-0">
                View Locations
              </Button>
            </Alert>
            <Modal
              show={showModal}
              title={
                <small>
                  {dropOffLocations.length} drop-off locations near {zipCode}
                </small>
              }
              onHide={() => {
                setShowModal(false);
              }}
            >
              <DropOffLocations locations={dropOffLocations} />
            </Modal>
          </>
        ) : null}

        {pickupBlocks.length ? (
          <div>
            {/*<Alert color="success">Pickups are available in your area.</Alert>*/}
          </div>
        ) : null}
      </div>
    );
  };

  const required = (value) => (value ? undefined : "Required");

  return (
    <form onSubmit={handleSubmit}>
      <PickupBlockResponse
        pickupBlocks={pickupBlocks}
        dropOffLocations={dropOffLocations}
      />
      <FormGroup>
        <Row>
          <Col xs={12}>
            <>
              {useableLocations && useableLocations.length > 0 ? (
                <PaginatedList perPage={5}>
                  {useableLocations.map((pickupLocation, index) => {
                    const { id, address, fullAddress, city, state, zip } =
                      pickupLocation;

                    let activePickup = location && location.id === id;

                    return (
                      <div
                        onClick={() => {
                          handleSelect(pickupLocation);
                        }}
                      >
                        <IconItem
                          Icon={Icons.OnRoute}
                          className={activePickup ? `active` : `disabled`}
                        >
                          <StatusText
                            title={address}
                            subTitle={`${city}, ${state}, ${zip}`}
                          />
                        </IconItem>
                      </div>
                    );
                  })}
                </PaginatedList>
              ) : null}
              <div
                className={""}
                onClick={() => {
                  showAddNewLocation();
                }}
              >
                <IconItem Icon={Icons.OnRoute} className={"disabled left"}>
                  <StatusText title={"New Address"} />
                </IconItem>
              </div>
              <div>
                <FormNavigation {...props} />
                {noPickupBlocksAlert ? (
                  <Alert color="warning">
                    Unfortunately we have not started to service your area yet.
                  </Alert>
                ) : null}
              </div>
            </>
          </Col>
        </Row>
        <Field
          name="addressInfo"
          component="input"
          validate={[requiredValidate]}
          type="hidden"
        />
        {errorMessage ? <Alert color="danger">{errorMessage}</Alert> : null}
      </FormGroup>
    </form>
  );
};

export default ChooseLocation;
